import { HttpInterceptorFn } from '@angular/common/http';

function readCookie(name: string): string | null {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

export const apiInterceptor: HttpInterceptorFn = (req, next) => {
  const headers: Record<string, string> = {};
  const mutating = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(req.method);
  const xsrf = readCookie('XSRF-TOKEN');

  if (mutating && xsrf) {
    headers['X-XSRF-TOKEN'] = xsrf;
  }

  return next(
    req.clone({
      withCredentials: true,
      setHeaders: headers,
    })
  );
};
